import React from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";

const BasicFileInput = ({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  name,
  type,
  placeholder,
  label,
  help,
  noFormGroup,
  onChange,
  onBlur,
  required,
  ajaxErrors,
  disabled,
  autocomplete,
  className: propsClass
}) => {
  const className = propsClass ? propsClass : "";
  const { t } = useTranslation();

  return (
    <div
      className={
        (touched[name] && errors[name]) ||
        (ajaxErrors && !touched[name] && ajaxErrors[name])
          ? (noFormGroup ? "" : "form-group m-form__group ") + "has-danger"
          : noFormGroup
          ? ""
          : "form-group m-form__group "
      }
    >
      {label && (
        <label htmlFor={name}>
          <Trans>{label}</Trans> {required ? "*" : ""}
        </label>
      )}
      <input
        className={"form-control m-input " + className}
        type={type}
        placeholder={t(placeholder)}
        name={name}
        id={name}
        onChange={e => {
          handleChange(e);
          if (onChange) {
            onChange(e);
          }
        }}
        onBlur={e => {
          handleBlur(e);
          if (onBlur) {
            onBlur(e);
          }
        }}
        required={!!required}
        disabled={!!disabled}
      />
      {help && (
        <span className="m-form__help">
          <Trans>{help}</Trans>
        </span>
      )}
      {touched[name] && errors[name] && (
        <div className="form-control-feedback">
          <Trans>{errors[name]}</Trans>
        </div>
      )}
      {ajaxErrors && !touched[name] && ajaxErrors[name] && (
        <div className="form-control-feedback">
          <Trans>{ajaxErrors[name]}</Trans>
        </div>
      )}
    </div>
  );
};

BasicFileInput.propTypes = {
  touched: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  values: PropTypes.any,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  noFormGroup: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  ajaxErrors: PropTypes.object,
  disabled: PropTypes.bool
};

export default BasicFileInput;
